import { QA_GET } from "constants/actionTypes";

const defaultState = {
    data: [],
    total: 0,
    pager: { pageSize: 20, current: 1 },
    error: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case QA_GET: {
            const error = !!action.error;
            const {
                send,
                payload: { total, data },
            } = action;

            const { pager } = send || {};
            const pagination = pager || state.pager;

            return {
                total: total || 0,
                pager: pagination,
                data,
                error,
            };
        }
        default:
            return state;
    }
};
